<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Ведомость цен на доставку</h6>
      </div>
      <div class="card-body">
        <div class="overflow-auto">
          <table class="table table-sm table-hover" v-if="Object.keys(deliveryData).length">
            <thead>
            <tr>
              <th></th>
              <th v-for="project in $AllProjects" v-if="project.is_active">
                <p>{{ project.name }}</p>
                <p>макс/норм/льгот</p>
                <p>сумма чека/доставка</p>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="city in $AllCities">
              <td>{{ city.name }}</td>
              <td v-for="project in $AllProjects" v-if="project.is_active">
                <!--                {{project.id}} - {{city.id}}-->
                <div class="flex">
                  <input @change="deliveryData[project.id][city.id].updated = true" v-model="deliveryData[project.id][city.id].max_price" type="text" class="form-control">
                  <input @change="deliveryData[project.id][city.id].updated = true" v-model="deliveryData[project.id][city.id].price" type="text" class="form-control">
                  <input @change="deliveryData[project.id][city.id].updated = true" v-model="deliveryData[project.id][city.id].exemption" type="text" class="form-control">
                </div>
                <div class="flex">
                  <input @change="deliveryData[project.id][city.id].updated = true" v-model="deliveryData[project.id][city.id].bill" type="text" p1laceholder="Чек" class="form-control">
                  <input @change="deliveryData[project.id][city.id].updated = true" v-model="deliveryData[project.id][city.id].bill_delivery" type="text" p1laceholder="Доставка" class="form-control">
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right">
          <vue-ladda @click="saveChanges" button-class="btn btn-success"
                     data-style="zoom-in"
                     :loading="loading">Сохранить
          </vue-ladda>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api';
import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  title: 'Стоимость доставки',
  components: {
    VueLadda
  },
  data() {
    return {
      loading: false,
      deliveryData: {}
    }
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter((s) => s.id && s.id !== 4)
      return _.orderBy(stores, 'id');
    },
    $AllCities() {
      let cities = this.$store.getters['platform/cities'];
      cities[0] = {id: 0, name: 'Почта', short_name: 'Почта'};
      return cities;
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getRecords() {
      const {data} = await api.index('/settings/orders/deliveryPrice');
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка сервера');
        return;
      }
      let records = {};
      data.records.forEach((r) => {
        if (!records[r.site_id]) records[r.site_id] = {};
        records[r.site_id][r.city_id] = r;
      });
      this.$AllProjects.forEach((p) => {
        Object.keys(this.$AllCities).forEach((ck) => {
          if (!records[p.id] || !records[p.id][ck]) {
            if (!records[p.id]) {
              records[p.id] = {};
            }
            records[p.id][ck] = {
              city_id: ck,
              site_id: p.id,
              bill: null,
              bill_delivery: null,
              exemption: null,
              max_price: null
            }
          }
        })
      });
      console.log(records);
      this.deliveryData = records;
    },
    async saveChanges() {
      let records = [];
      Object.keys(this.deliveryData).forEach((siteId) => {
        Object.keys(this.deliveryData[siteId]).forEach((cityId) => {
          if (this.deliveryData[siteId][cityId].updated) records.push(this.deliveryData[siteId][cityId]);
        })
      });

      if (!records.length) return;
      this.loading = true;
      const {data} = await api.post('/settings/orders/deliveryPrice', {records});
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка сервера');
      } else {
        records.forEach((r) => {
          this.deliveryData[r.site_id][r.city_id].updated = false;
        })
        toastr['success'](data.message || 'Сохранено');
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
table.table input {
  font-weight: 600;
  padding: 1px 8px;
}

::-webkit-input-placeholder {
  font-weight: 400;
}

:-moz-placeholder {
  font-weight: 400;
}

::-moz-placeholder {
  font-weight: 400;
}

:-ms-input-placeholder {
  font-weight: 400;
}

table.table th p {
  margin-bottom: 2px;
}

table.table th {
  text-align: center;
}
</style>
